import React from 'react';
import TiptapEditor from '../../../../components/Notes/Editor/TiptapEditor';
import RecapTierBanner from './RecapTierBanner';
import './RecapTierEditor.css';

/**
 * One Lesson Recap tier: its audience banner over a TipTap editor. The banner
 * is not decoration — it is the thing that stops a teacher writing parent copy
 * into the everyone tier, so it sits immediately above the field it labels.
 *
 * Uncontrolled: `content` seeds the editor once (loaded draft); edits flow out
 * through onUpdate and are debounced/persisted by useRecapDrafts. Re-feeding
 * content on every keystroke would fight the editor's own state.
 */
const RecapTierEditor = ({
	tier,
	content,
	onUpdate,
	students = [],
	studentName = '',
	parentName = '',
	unlinked = false,
}) => (
	<div className="ld-tiereditor">
		<RecapTierBanner
			tier={tier}
			studentName={studentName}
			parentName={parentName}
			unlinked={unlinked}
		/>
		<div className="ld-tiereditor__field">
			<TiptapEditor
				content={content}
				onUpdate={onUpdate}
				students={students}
				placeholder={tier.placeholder(studentName, parentName)}
			/>
		</div>
	</div>
);

export default RecapTierEditor;
